import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import ClientDossier from "@/pages/admin/ClientDossier";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminContentSpace from "@/pages/admin/AdminContentSpace";

import ClientLayout from "@/components/client/ClientLayout";
import ClientDashboard from "@/pages/client/ClientDashboard";
import ClientParcours from "@/pages/client/ClientParcours";
import ClientPhase from "@/pages/client/ClientPhase";
import ProgrammePage from "@/pages/client/ProgrammePage";
import ModuleView from "@/pages/client/ModuleView";
import ClientTasks from "@/pages/client/ClientTasks";
import ComingSoon from "@/pages/client/ComingSoon";
import ElevateHub from "@/pages/client/ElevateHub";
import HubAvis from "@/pages/client/HubAvis";
import HubBookCall from "@/pages/client/HubBookCall";
import HubClosing from "@/pages/client/HubClosing";
import HubCrm from "@/pages/client/HubCrm";
import ContentSpace from "@/pages/client/ContentSpace";
import ARevoir from "@/pages/client/ARevoir";
import Planning from "@/pages/client/Planning";
import PaymentPlan from "@/pages/client/PaymentPlan";
import Facture from "@/pages/client/Facture";

function Loader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <span className="logo-elevate text-4xl text-bordeaux">elevate</span>
    </div>
  );
}

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/espace"} replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === undefined) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/espace"} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/bienvenue" element={<SetPassword />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reinitialiser" element={<ResetPassword />} />

            <Route path="/admin" element={<Protected role="admin"><AdminLayout /></Protected>}>
              <Route index element={<AdminDashboard />} />
              <Route path="clientes" element={<AdminClients />} />
              <Route path="clientes/:id" element={<ClientDossier />} />
              <Route path="clientes/:id/contenu" element={<AdminContentSpace />} />
              <Route path="calendrier" element={<AdminCalendar />} />
            </Route>

            <Route path="/espace" element={<Protected role="cliente"><ClientLayout /></Protected>}>
              <Route index element={<ClientDashboard />} />
              <Route path="parcours" element={<ClientParcours />} />
              <Route path="parcours/:phase" element={<ClientPhase />} />
              <Route path="programme/:slug" element={<ProgrammePage />} />
              <Route path="module/:id" element={<ModuleView />} />
              <Route path="hub" element={<ElevateHub />} />
              <Route path="hub/avis" element={<HubAvis />} />
              <Route path="hub/book-a-call" element={<HubBookCall />} />
              <Route path="hub/closing" element={<HubClosing />} />
              <Route path="hub/crm" element={<HubCrm />} />
              <Route path="creation-contenu" element={<ContentSpace />} />
              <Route path="a-revoir" element={<ARevoir />} />
              <Route path="taches" element={<ClientTasks />} />
              <Route path="planning" element={<Planning />} />
              <Route path="paiement" element={<PaymentPlan />} />
              <Route path="facture" element={<Facture />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
